<script>
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import {
  GravyPath,
  WarehousePath,
  LocationPath,
  PackagingPath,
} from "@/path.js";
import axios from "axios";
import Swal from "sweetalert2";
import { RestaurantsPath } from "@/path";
export default {
  props: ["mainOrder"],
  components: {
    SelectWithSearch,
  },
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      // form: {
      //   type: null,
      //   batch_code: null,
      //   warehouse_id: null,
      //   location_id: null,
      //   production_on: null,
      // },
      order_items: [],
      selectedOrder: null,
      fields: ["batch_code", "item", "qty_returned", "actions"],
      type: "gravy",
      currentPage: 1,
      date_of_return: null,
      type_of_return: "over_stock",
      should_return_to_inventory: false,
      barcode: "",
      key: 1,
      form: {
        data: [],
        type: "restaurant",
        type_of_return: "product_discontinued",
      },
      types: [
        {
          value: "product_discontinued",
          text: "Product Discontinued",
        },
        {
          value: "over_stock",
          text: "Over Stock",
        },
        {
          value: "spoil",
          text: "Spoiled",
        },
        {
          value: "expired",
          text: "Expired",
        },
        {
          value: "wrong_items",
          text: "Wrong Items",
        },
        {
          value: "non_moving_items",
          text: "Non Moving Items",
        },
        {
          value: "spillage",
          text: "Spillage",
        },
        {
          value: "outlet_closed",
          text: "Outlet Closed",
        },
        {
          value: "new_outlet_training",
          text: "New Outlet Training",
        },
        {
          value: "new_item_training",
          text: "New Item Training",
        },
        {
          value: "retraining",
          text: "Retraining",
        },
        {
          value: "spoiled_by_rp",
          text: "Spoiled (RP Negligence)",
        },
      ],
    };
  },
  watch: {
    "form.type"() {
      this.form.res_id = null;
    },
  },
  computed: {
    GravyPath() {
      return GravyPath;
    },
    PackagingPath() {
      return PackagingPath;
    },
    RestaurantsPath() {
      return RestaurantsPath;
    },
    WarehousePath() {
      return WarehousePath;
    },
    LocationPath() {
      return LocationPath;
    },
  },
  methods: {
    deleteItem(v) {
      const index = this.form.data.findIndex(
        (item) => item.gravy_id === v.item.gravy_id
      );
      this.form.data.splice(index, 1);
    },
    selectedType(v) {
      if (v == "gravy") {
        this.type = "gravy";
      } else {
        this.type = "packaging";
      }
      this.currentPage = 1;
      this.key += 1;
    },
    checkQty(v) {
      if (v.item.qty_returned > v.item.qty_shipped) {
        Swal.fire("Qty Cannot be greater than sent", "", "error");
        this.order_items[v.index].qty_returned = v.item.qty_shipped;
        this.key += 1;
      }
    },
    async saveData() {
      try {
        let res;
        if (!this.mainOrder) {
          res = await axios.post(
            this.base_url + GravyPath.ORDERS.SAVE_RETURNS,
            {
              items: this.form.data.map((f) => {
                return {
                  gravy_id: f?.gravy_id,
                  packaging_id: f?.packaging_id,
                  qty: f.qty,
                  qty_pcs: f.qty_pcs,
                };
              }),
              res_id: this.form.res_id,
              type: this.form.type,
              date_of_return: this.form.date_of_return,
              type_of_return: this.form.type_of_return,
              should_return_to_inventory: this.form.should_return_to_inventory,
              warehouse_id: this.form.warehouse_id,
              location_id: this.form.location_id,
            }
          );
        } else {
          res = await axios.post(
            this.base_url + GravyPath.ORDERS.UPDATE_RETURNS,
            {
              id: this.mainOrder.id,
              items: this.form.data.map((f) => {
                return {
                  gravy_id: f?.gravy_id,
                  packaging_id: f?.packaging_id,
                  qty: f.qty,
                  qty_pcs: f.qty_pcs,
                };
              }),
              res_id: this.form.res_id,
              type: this.form.type,
              date_of_return: this.form.date_of_return,
              type_of_return: this.form.type_of_return,
              should_return_to_inventory: this.form.should_return_to_inventory,
              warehouse_id: this.form.warehouse_id,
              location_id: this.form.location_id,
            }
          );
        }
        if (res.data.status) {
          Swal.fire("Created Successfully", "", "success");
          this.$bvModal.hide("add-return");
          this.$emit("reload");
        } else {
          Swal.fire("Failed to create", "", "error");
        }
      } catch (e) {
        console.log(e);
        Swal.fire("Failed to create", "", "error");
      }
    },
    async selectedOrders(v) {
      try {
        this.selectedOrder = v.id;
        this.order_items = v.order_items.map((f) => {
          f.qty_returned = f.qty_shipped;
          return f;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async addGravyOrPackaging(v, type) {
      if (
        type == "gravy" &&
        this.form.data.some((item) => item.gravy_id == v.id)
      )
        return;
      if (
        type == "packaging" &&
        this.form.data.some((item) => item.packaging_id == v.id)
      )
        return;
      if (type == "gravy") {
        this.form.data.push({
          gravy_id: v.id,
          gravy: v,
          qty: 0,
          qty_pcs: 0,
          units: v.units,
          uom: v.uom,
        });
      } else {
        this.form.data.push({
          packaging_id: v.id,
          packaging: v,
          qty: 0,
          qty_pcs: 0,
          units: v.uom,
          uom: v.units,
        });
      }
    },
    async processBarcode(v) {
      try {
        let res = await axios.get(
          this.base_url + GravyPath.FETCH_GRAVY_WITH_BATCH,
          {
            params: {
              batch_code: v,
              warehouse_id: this.forms.warehouse_id,
              location_id: this.forms.location_id,
            },
          }
        );
        console.log(res);
        // if (res.data) {
        //   this.form.data.push(res.data);
        // }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    if (this.mainOrder) {
      console.log(this.mainOrder, "uu");
      this.form.data = this.mainOrder.items.map((m) => {
        if (m.gravy) {
          return {
            gravy_id: m.gravy.id,
            gravy: m.gravy,
            qty: m.qty_returned,
            qty_pcs: m.qty_returned_pcs,
            units: m.gravy.units,
            uom: m.gravy.uom,
          };
        } else {
          return {
            packaging_id: m.packaging.id,
            packaging: m.packaging,
            qty: m.qty_returned,
            qty_pcs: m.qty_returned_pcs,
            units: m.packaging.uom,
            uom: m.packaging.units,
          };
        }
      });
      this.form.type = this.mainOrder.type;
      this.form.res_id = this.mainOrder.restaurant?.id;
      this.form.warehouse_id = this.mainOrder.warehouse_id;
      this.form.location_id = this.mainOrder.location_id;
      this.form.date_of_return = this.mainOrder.date_of_return;
      this.form.type_of_return = this.mainOrder.type_of_return;
      this.form.should_return_to_inventory =
        this.mainOrder.should_return_to_inventory == 1 ? true : false;
    }
  },
};
</script>

<template>
  <b-card>
    <b-card-body>
      <b-row>
        <b-col sm="12">
          <label>Type Of Return</label>
          <b-form-radio-group v-model="form.type" stacked>
            <b-form-radio value="restaurant" class="mb-1"
              >Restaurant</b-form-radio
            >
            <b-form-radio value="warehouse" class="mb-1"
              >Warehouse</b-form-radio
            >
          </b-form-radio-group>
        </b-col>
        <b-col sm="4" v-if="form.type == 'restaurant'">
          <label>Restaurant</label>
          <SelectWithSearch
            v-if="!mainOrder"
            :search_api="RestaurantsPath.GET_RESTAURANTS"
            display="name"
            track_by="id"
            :full_object="true"
            @selectedOption="(v) => (form.res_id = v.id)"
          ></SelectWithSearch>
          <p v-else>{{ mainOrder?.restaurant?.name }}</p>
        </b-col>
        <b-col sm="4">
          <label>Warehouse</label>
          <SelectWithSearch
            :selected_data="[form.warehouse_id]"
            selected_by="id"
            :search_api="WarehousePath.WAREHOUSE_SEARCH"
            track_by="id"
            display="name"
            @selectedOption="
              (v) => {
                form.warehouse_id = v;
                key += 1;
              }
            "
          ></SelectWithSearch>
        </b-col>
        <b-col sm="4">
          <label>Location</label>
          <SelectWithSearch
            v-if="form.warehouse_id"
            :selected_data="[form.location_id]"
            selected_by="id"
            :key="key"
            :search_api="LocationPath.LOCATION_SEARCH"
            track_by="id"
            display="location"
            @selectedOption="(v) => (form.location_id = v)"
            :extra_params="'&warehouse_id=' + form.warehouse_id"
          ></SelectWithSearch>
        </b-col>
        <b-col sm="4">
          <label>Type Of Return</label>
          <b-form-select
            :options="types"
            v-model="form.type_of_return"
          ></b-form-select>
        </b-col>
        <b-col sm="4">
          <label
            >Date Of
            {{
              [
                "new_outlet_training",
                "new_item_training",
                "retraining",
              ].includes(form.type_of_return)
                ? "Training"
                : "Return"
            }}</label
          >
          <b-datepicker v-model="form.date_of_return"></b-datepicker>
        </b-col>
        <!-- <b-col sm="4" class="mt-4 mb-4 d-flex">
          <b-checkbox v-model="form.should_return_to_inventory"
            >Should Add to Inventory</b-checkbox
          >
        </b-col> -->
      </b-row>
      <!-- <input
        type="text"
        v-model="barcode"
        @keyup.enter="processBarcode(barcode)"
        ref="barcodeInput"
        placeholder="Scan a barcode"
        class="form-control mb-4 mt-2"
      /> -->
      <b-tabs class="mt-5">
        <b-tab title="Gravy" @click="selectedType('gravy')" class="mt-2">
          <label>Select Gravy</label>
          <SelectWithSearch
            selected_by="id"
            :key="key"
            :search_api="GravyPath.SEARCH_GRAVIES"
            track_by="id"
            display="name"
            :full_object="true"
            @selectedOption="(v) => addGravyOrPackaging(v, 'gravy')"
          >
          </SelectWithSearch>
        </b-tab>
        <b-tab
          title="Packaging"
          @click="selectedType('packaging')"
          class="mt-2"
        >
          <label>Select Packaging</label>
          <SelectWithSearch
            selected_by="id"
            :key="key"
            :search_api="PackagingPath.SEARCH_PACKAGING"
            track_by="id"
            display="name"
            :full_object="true"
            @selectedOption="(v) => addGravyOrPackaging(v, 'packaging')"
          >
          </SelectWithSearch>
        </b-tab>
      </b-tabs>
      <b-table
        :key="key"
        :items="
          form.data.filter((f) =>
            type == 'gravy' ? f.gravy != null : f.packaging != null
          )
        "
        :fields="fields"
        :current-page="currentPage"
        :per-page="10"
      >
        <template v-slot:cell(item)="row">
          <p v-if="row.item.gravy != null">{{ row.item.gravy.name }}</p>
          <p v-if="row.item.packaging != null">{{ row.item.packaging.name }}</p>
        </template>
        <template v-slot:cell(qty_returned)="row">
          <div style="display: flex; flex-direction: column; gap: 4px">
            <div style="display: flex; align-items: center; gap: 4px">
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="row.item.qty--"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.qty == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input type="number" v-model="row.item.qty" min="0" />
                <b-input-group-append>
                  <b-button @click="row.item.qty++" size="sm" variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
              <span>Pkts</span>
            </div>
            <div
              style="display: flex; align-items: center; gap: 4px"
              v-if="row.item.units == 'pcs'"
            >
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="row.item.qty_pcs--"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.qty_pcs == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  v-model="row.item.qty_pcs"
                  min="0"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="row.item.qty_pcs++"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
              <span>pcs</span>
            </div>
            <div v-if="row.item.units == 'pcs'">
              Total :
              {{
                (
                  (row.item.qty ?? 0) +
                  (row.item.qty_pcs ?? 0) / row.item.uom
                ).toFixed(2)
              }}
              Pkts
            </div>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button variant="danger" @click="deleteItem(row)"
            ><i class="fa fa-trash"></i
          ></b-button>
        </template>
      </b-table>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul
              class="pagination pagination-rounded"
              style="margin-top: 0px !important"
            >
              <!-- pagination -->
              <b-pagination
                :key="form.data.key"
                v-model="currentPage"
                :total-rows="form.data?.length"
                :per-page="10"
                class="dataTables_paginate"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <b-button variant="success" @click="saveData">Save Data</b-button>
    </b-card-body>
  </b-card>
</template>

<style></style>
